import React from 'react';
import Uld from './Uld';
import events from 'utils/evemts';
import http from 'utils/http';
import { setDeleteAction } from 'store/actions/deleteAction';
import { connect } from 'react-redux';
class UldContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      uldModal: false,
      uldFields: {},
      uldErrors: {},
      action: null,
    };
    this.eventSource = null;
  }

  componentDidMount() {
    this.fetchMail();
    this.eventSource = events('admin', 'uld');
    this.eventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');
      if (msg.action == 'add') {
        this.setState({ data: [...this.state.data, msg.data] });
      }
      if (msg.action == 'update' || msg.action == 'delete') {
        const data = [...this.state.data];
        const index = data.findIndex(d => msg.data && d.id == msg.data.id);
        if (msg.action == 'update') {
          if (index > -1) {
            data[index] = msg.data;
            this.setState({ data });
          } else {
            this.setState({ data: [...this.state.data, msg.data] });
          }
        }
        if (msg.action == 'delete') {
          if (index > -1) {
            data.splice(index, 1);
            this.setState({ data });
          }
        }
      }
    };
  }

  componentWillUnmount() {
    this.eventSource.close();
  }

  fetchMail = () => {
    http.get('/uld').then(({ data }) => {
      if (data.status == 'success') {
        this.setState({ data: data.data });
      }
    });
  };

  onChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    if (e.target.type === 'checkbox') {
      value = e.target.checked ? e.target.name : '';
      name = 'ac_type';
      let acTypes = this.state.uldFields.ac_type || [];
      acTypes = acTypes.includes(value) ?
        acTypes.filter(type => type !== value) :
        [...acTypes, value];
      value = acTypes;
      value = value.filter(v => v !== '');
    }
    this.setState({
      uldFields: {
        ...this.state.uldFields,
        [name]: value
      }
    });
  };

  validation = () => {
    const uldFields = { ...this.state.uldFields };
    const error = {};
    let formValid = true;
    if (!uldFields.prefix   || uldFields.prefix.trim() === '') {
      error.prefix = 'Prefix is required';
      formValid = false;
    }
    if (!uldFields.type || uldFields.type.trim() === '') {
      error.type = 'Type is required';
      formValid = false;
    }
    // if (!uldFields.ac_type || uldFields.ac_type.length === 0) {
    //   error.ac_type = 'At least one AC Type is required';
    //   formValid = false;
    // }
    this.setState({ uldErrors: error });
    return formValid;
  };

  addMail = async (e) => {
    e.preventDefault();
    let formdata = { ...this.state.uldFields };
    if (this.validation()) {
      http.post('/uld', formdata).then(({ data }) => {
        if (data.status == 'success') {
          this.setState({
            uldModal: false,
            uldFields: {},
            uldErrors: {},
            action: null,
          });
        }
      });
    }
  };

  editMail = async (e) => {
    e.preventDefault();
    let formdata = { ...this.state.uldFields };
    if (this.validation()) {
      http.put('/uld/' + formdata.id, formdata).then(({ data }) => {
        if (data.status == 'success') {
          this.setState({
            uldModal: false,
            uldFields: {},
            uldErrors: {},
            action: null,
          });
        }
      });
    }
  };

  deleteMail = (id) => {
    http.delete('/uld/' + id).then(({ data }) => {
      if (data.status == 'success') {
        this.props.setDelete({
          modal: false,
          id: false,
          anchorEl: false,
          onConfirm: () => { },
        });
      }
    });
  };
  handleDelete = (id, anchorEl) => {
    this.props.setDelete({
      modal: true,
      id,
      anchorEl,
      onConfirm: () => this.deleteMail(id),
    });
  };

  handleOpen = (action, data = {}) => {
    this.setState({
      action,
      uldFields: data,
      uldModal: true
    });
  };

  onClose = () => {
    this.setState({ uldModal: false });
  };

  render() {
    return (
      <>
        <Uld
          data={this.state.data}
          uldModal={this.state.uldModal}
          action={this.state.action}
          uldFields={this.state.uldFields}
          uldErrors={this.state.uldErrors}
          onChange={this.onChange}
          addMail={this.addMail}
          editMail={this.editMail}
          handleDelete={this.handleDelete}
          handleOpen={this.handleOpen}
          onClose={this.onClose}
        />
      </>
    );
  }
}


const mapDispatchToProps = (dispatch) => {
  return { setDelete: (data) => dispatch(setDeleteAction(data)) };
};

export default connect(null, mapDispatchToProps)(UldContainer);